module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight--dark-14b75d6594f7f0fcc2008f55e012520f.png";